module.exports = __webpack_public_path__ + "img/analyzing-photo-mobile-en.4a2af4eb.jpg";